var vars = require('./core');

module.exports = vars.createClass('Pie', ['getSegmentsAtEvent']);



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-chartjs/lib/pie.js
 ** module id = 971
 ** module chunks = 2
 **/